import React, { useEffect, useState } from "react";
import axios from "axios";
import SeatMap from "../components/SeatMap";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;

const LibrarySeatMap = () => {
  const [seatData, setSeatData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLibrarySeats = async () => {
      try {
        const res = await axios.get(`${API}library/seats/live-map/`);
        setSeatData(res.data);
        setError("");
      } catch (err) {
        setError("⚠️ Could not load library seat data.");
      } finally {
        setLoading(false);
      }
    };

    fetchLibrarySeats();
  }, []);

  const handleSeatClick = (seat) => {
    navigate(`/library/book/${seat.id}`);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>📚 Library Live Seats</h2>
      {loading ? (
        <p>Loading seats...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <SeatMap data={seatData} onSeatClick={handleSeatClick} />
      )}
    </div>
  );
};

export default LibrarySeatMap;
